const Globe = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.5 12a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0m7.556 5.667q-.78 0-1.334-.555a1.82 1.82 0 0 1-.555-1.334v-.945L4.682 10.35a7.501 7.501 0 0 0 6.373 9.092zm3.223-10.944q.554-.555.554-1.334v-.335a7.502 7.502 0 0 1 2.72 11.988 1.86 1.86 0 0 0-.666-.898q-.495-.366-1.11-.366h-.944v-2.834a.91.91 0 0 0-.271-.673.91.91 0 0 0-.673-.271H8.222v-1.889h1.89q.4 0 .672-.271a.91.91 0 0 0 .272-.673v-1.89h1.889q.779 0 1.333-.554"
      clipRule="evenodd"
    />
  </>
)
export default Globe
